import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  fetchFieldsFailure,
  fetchFieldsStart,
  fetchFieldsSuccess,
} from "../../../store/features/customer/fields/fieldsSlice";

const URL = buildApiUrl("/api/v1/field/field/");

const getFieldsApi = async (accessToken, search = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: search || null,
        // Cache-buster: ensure both admin and customer dashboards always
        // receive a fresh fields list from BE (e.g. after logout/login).
        _: Date.now(),
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchFieldsSaga(action) {
  try {
    const { accessToken, search } = action.payload;
    const fieldsData = yield call(getFieldsApi, accessToken, search);
    yield put(fetchFieldsSuccess(fieldsData));
  } catch (error) {
    yield put(fetchFieldsFailure(error.message));
  }
}

export default function* fieldsSaga() {
  yield takeLatest(fetchFieldsStart.type, fetchFieldsSaga);
}
